import React from "react";
import { Input, Space } from "antd"; // Assuming antd for Input and Space

const OTPInput = ({ otp, onChange }) => {
  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.toUpperCase(); // Force uppercase

    onChange(newOtp); // Inform parent about the change

    // Auto-focus next input
    if (value && index < newOtp.length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  return (
    <Space>
      {otp.map((digit, index) => (
        <Input
          key={index}
          id={`otp-${index}`}
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          style={{ width: 36, textAlign: "center" }}
        />
      ))}
    </Space>
  );
};

export default OTPInput;
